// removed by extract-text-webpack-plugin
module.exports = {"SimpleModal":"Simple-cssmodule-SimpleModal-3PEOR","title":"Simple-cssmodule-title-1N7Rc","contentView":"Simple-cssmodule-contentView-3azMw","content":"Simple-cssmodule-content-1nDLw","description":"Simple-cssmodule-description-3mgSG","media":"Simple-cssmodule-media-1krWF","button":"Simple-cssmodule-button-2KLJp","cancelButton":"Simple-cssmodule-cancelButton-2GrVv"};


//////////////////
// WEBPACK FOOTER
// ./themes/BlueTheme/Simple.cssmodule.less
// module id = 680
// module chunks = 0